import { singleton } from "tsyringe";
import { BehaviorSubject } from 'rxjs';

export interface StudioError {
    code: string;
    message: string;
    type: 'unknown' | 'network' | 'poor_network' | 'destination' | 'fatal';
}

@singleton()
export class ErrorService {
    private error$ = new BehaviorSubject<StudioError>(null);

    public get errorObservable() { return this.error$.asObservable(); }

    public throwError(error: StudioError) {
        console.error(error);
        this.error$.next(error);
    }
}
